import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

import HorizontalSplitOutlinedIcon from '@mui/icons-material/HorizontalSplitOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import ImportantDevicesOutlinedIcon from '@mui/icons-material/ImportantDevicesOutlined';

const Orion = () => {
    return (
        <Grid container spacing={3} className="hermes-container">
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <HorizontalSplitOutlinedIcon /> Design
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Visually create async workflows and modular thread handlers.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Design Workflow
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <PendingActionsOutlinedIcon /> Schedule
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Schedule and control timing of background threads and delayed actions.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Schedule Tasks
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <ImportantDevicesOutlinedIcon /> Monitor
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Monitor active threads, error rates, retries and execution duration.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Monitor Activity
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Orion;